import React from 'react';
export function PaymentBadges() {
  return <div className="flex flex-wrap items-center justify-center gap-3" data-id="element-223">
      <div className="bg-[#1A1F71] text-white px-4 py-2 rounded font-bold text-sm" data-id="element-224">
        VISA
      </div>
      <div className="bg-gradient-to-r from-red-600 to-orange-500 text-white px-4 py-2 rounded font-bold text-sm" data-id="element-225">
        Mastercard
      </div>
      <div className="bg-[#0070BA] text-white px-4 py-2 rounded font-bold text-sm" data-id="element-226">
        PayPal
      </div>
      <div className="bg-[#006FCF] text-white px-4 py-2 rounded font-bold text-sm" data-id="element-227">
        American Express
      </div>
      <div className="bg-black text-white px-4 py-2 rounded font-bold text-sm" data-id="element-228">
        Apple Pay
      </div>
    </div>;
}